import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * TimeRangeFilter - Segmented time range selector with clear spacing.
 */
const TimeRangeFilter = ({ value, onChange }) => {
    const { t } = useTranslation();

    const TIME_RANGES = [
        { value: '7days', label: t('systemDashboard.filters.last7days') },
        { value: '30days', label: t('systemDashboard.filters.last30days') },
        { value: 'year', label: t('systemDashboard.filters.lastYear') },
        { value: 'all', label: t('systemDashboard.filters.allTime') },
        { value: 'custom', label: t('systemDashboard.filters.custom') }
    ];

    return (
        <div className="sd-time-range">
            <span className="sd-time-range__label">{t('systemDashboard.filters.period')}</span>
            <div className="sd-time-range__options">
                {TIME_RANGES.map((range) => {
                    const isActive = value === range.value;
                    return (
                        <button
                            key={range.value}
                            onClick={() => onChange(range.value)}
                            className={`sd-time-range__button ${isActive ? 'sd-time-range__button--active' : ''}`}
                        >
                            {range.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TimeRangeFilter;
